/**
 * The shared coordinate space for the "How Wonder Works" curve.
 *
 * Its own module, not part of JourneyCurve, so both the SVG and the HTML step
 * blocks can read the same numbers: the steps position themselves as
 * percentages of this viewBox, and a curve that moved without them moving with
 * it would leave every label pointing at nothing.
 */
export const VIEWBOX = { width: 1150, height: 580 };

/**
 * Where each node sits, and how far its dotted dropline falls to the copy.
 *
 * Traced off the Figma frame rather than drawn to taste. The frame's content
 * box runs from (255, 70) to (1660, 770) on a 1920 canvas; every figure here
 * is that box mapped onto the viewBox, so the numbers can be checked against
 * the design by anyone with the file open. Node 3 sits eleven units below the
 * top edge -- exactly its own radius -- which is as high as it can go without
 * the SVG clipping it.
 */
export const NODES = [
  { x: 151, y: 420, dropTo: 497 },
  { x: 618, y: 274, dropTo: 456 },
  { x: 909, y: 11, dropTo: 157 },
];

export const PATH =
  // Three sweeps and a tail, one cubic each, and every join is a horizontal
  // tangent -- so the line is G1-smooth end to end and each node sits on a
  // level: the floor of the dip for 1, the slow point of the rise for 2, the
  // crest for 3.
  //
  // One sweep from node 1 to node 2, not two. An earlier pass drew the rise as
  // its own S landing on a dead-straight run into node 2, and the joins read
  // as corners -- the frame has no flat there, just a single S that leaves the
  // dip, inflects about a third of the way across, and eases into node 2 as
  // the rise slows. The control points are set asymmetrically to put that
  // inflection where the frame has it, left of the segment's midpoint.
  //
  // The second sweep runs out of node 2 nearly level before it climbs, which
  // is what keeps the dot on a slow point rather than a crest, and arrives at
  // node 3 level so the tail carries straight on.
  //
  // The leg out of node 1 stays on the floor before it climbs, so it passes
  // under the heading block's buttons rather than through them -- that column
  // is fixed CSS pixels while the curve scales with the viewport, so a leg that
  // only just clears the buttons here crosses them on a shorter window.
  //
  // It runs the full width of the box, edge to edge: the frame fades the line
  // out at both ends rather than stopping it short of them.
  'M 0 368 C 45 375, 105 420, 151 420 ' +
  'C 260 420, 430 274, 618 274 ' +
  'C 760 274, 820 11, 909 11 ' +
  'C 990 11, 1080 5, 1150 4';

/** Position within the viewBox as CSS percentages, for absolutely placed HTML. */
export function atViewBox(x, y) {
  return {
    left: `${(x / VIEWBOX.width) * 100}%`,
    top: `${(y / VIEWBOX.height) * 100}%`,
  };
}
